import {mapOverlayPanes} from "base/component/geo";

import {ciOptions} from "./CiOptions";
import {createLayerLegend, useLayerObject} from "base/map";
import {generatePopupHTML} from "app/common/PopupUtil";

export const markerBaseOptions = {
    marker: "H",
    fillColor: "#b7484b",
    radius: 10,
    color: "#ffffff",
    addStroke: true,
    weight: 2,
    opacity: 1,
    fillOpacity: 0.8,
    pane: mapOverlayPanes[6],
    interactive: false,
};

export const discriminators = Object.freeze({
    CI: "ci",
    CI_HOR: "ci_hor",
    CI_VER: "ci_ver",
    CI_SPA: "ci_spa",
    CI_RES: "ci_res",
    CI_COM: "ci_com",
});

const createLegendEntries = options => {
    return options.map(option => ({
        text: option.text,
        filterFn: option.fn,
        markerOptions: {
            ...markerBaseOptions,
            fillColor: option.fillColor,
            color: option.color,
        },
    }));
};

export const ciEntries = createLegendEntries(ciOptions);
export const ciHorEntries = createLegendEntries(ciOptions);
export const ciVerEntries = createLegendEntries(ciOptions);
export const ciSpaEntries = createLegendEntries(ciOptions);
export const ciResEntries = createLegendEntries(ciOptions);
export const ciComEntries = createLegendEntries(ciOptions);

// Field configuration for coordination indexes tooltip
const coordinationindexesFieldConfig = [
    {key: "country", label: "Country"},
    {key: "ci_txt", label: "CI"},
    {key: "ci_hor_txt", label: "CI Horizontal"},
    {key: "ci_ver_txt", label: "CI Vertical"},
    {key: "ci_spa_txt", label: "CI Spatial"},
    {key: "ci_res_txt", label: "CI Resources"},
    {key: "ci_com_txt", label: "CI Communication"},
];

// Separate function for tooltip content
const createCoordinationindexesTooltip = data => {
    return generatePopupHTML(
        "Coordination Index",
        data,
        coordinationindexesFieldConfig
    );
};

const LayerLegend = createLayerLegend({
    layerName: "Coordination Index",
    menuIconShape: markerBaseOptions.marker,
    discriminatorsAttributes: discriminators,
    discriminatorsLegends: [
        {
            field: discriminators.CI,
            text: "CI",
            defaultIconOptions: markerBaseOptions,
            entries: ciEntries,
        },
        {
            field: discriminators.CI_HOR,
            text: "Horizontal",
            defaultIconOptions: markerBaseOptions,
            entries: ciHorEntries,
        },
        {
            field: discriminators.CI_VER,
            text: "Vertical",
            defaultIconOptions: markerBaseOptions,
            entries: ciVerEntries,
        },
        {
            field: discriminators.CI_SPA,
            text: "Spatial",
            defaultIconOptions: markerBaseOptions,
            entries: ciSpaEntries,
        },
        {
            field: discriminators.CI_RES,
            text: "Resources",
            defaultIconOptions: markerBaseOptions,
            entries: ciResEntries,
        },
        {
            field: discriminators.CI_COM,
            text: "Communication",
            defaultIconOptions: markerBaseOptions,
            entries: ciComEntries,
        },
    ],
});

export default function useCoordinationindexesLayer(onSelectElement) {
    return useLayerObject({
        legend: LayerLegend,
        detail: false,
        getTooltip: ({feature}) => {
            let data = feature.properties;
            return createCoordinationindexesTooltip(data);
        },
        // getCustomMarkerOptions: onSelectElement ? () => markerBaseOptions : null,
        // defaultOnClick: ({feature}) => onSelectElement(feature.id),
    });
}
